import { FC, useEffect } from "react";

import { cx } from "@emotion/css";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";

import { useMenu } from "components/Menu/context";

import "./MenuStateIcon.scss";
import { menuStateIconStyles as styles } from "./MenuStateIcon.styles";

export const MenuStateIcon: FC = () => {
  const { menuOpen, setMenuOpen, subMenuOpen, setSubMenuClose } = useMenu();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let iconState: "open" | "close" | "back" = "close";
  if (!menuOpen) {
    iconState = "open";
  } else if (isMobile && subMenuOpen) {
    iconState = "back";
  }

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("keydown", handler);
    }

    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [menuOpen]);

  const onClick = () => {
    if (iconState === "back") {
      setSubMenuClose();
    } else if (iconState === "close") {
      setMenuOpen(false);
    } else {
      setMenuOpen(true);
    }
  };

  return (
    <IconButton
      onClick={onClick}
      aria-label={`${iconState} menu`}
      data-testid="menu-hamburger-button"
    >
      <Icon state={iconState} />
    </IconButton>
  );
};

const Icon: FC<{ state: "open" | "back" | "close" }> = ({ state }) => {
  return (
    <div css={styles.burgerWrapper}>
      <div
        data-testid="menu-hamburger-icon"
        className={cx("hamburger-icon", "is-active", {
          "hamburger--slider": state === "close",
          "hamburger--arrow": state === "back",
        })}
      >
        <div className="hamburger-box">
          <div className="hamburger-inner" />
        </div>
      </div>
    </div>
  );
};
